import { render, staticRenderFns } from "./GPToCostReportTable.vue?vue&type=template&id=17d4cfd6"
import script from "./GPToCostReportTable.vue?vue&type=script&lang=js"
export * from "./GPToCostReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports